<template>
  <div>
    <p class="titleText ma-0 pa-0">{{ title }}</p>
    <p class="value ma-0 pa-0">{{ value === 'Sem Dados' ? value : `+${value}%` }}</p>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      required: true
    }
  }
};
</script>

<style scoped>
.titleText {
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.16px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #616161;
}

.value {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.16px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #00ac69;
}
</style>